"use strict";
//* создание кнопки показать еще 
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComandButtonLamp = void 0;
var ComandButtonLamp;
(function (ComandButtonLamp) {
    ComandButtonLamp["Create"] = "create";
    ComandButtonLamp["Delete"] = "delete";
})(ComandButtonLamp || (exports.ComandButtonLamp = ComandButtonLamp = {}));
const createButtonStillLamps = (command) => {
    const numberLampsBody = document.querySelector('#body-for-button-still-lamps');
    if (command === 'create') {
        const button = document.querySelector('#button-add-lamps');
        if (!button) {
            numberLampsBody?.insertAdjacentHTML('beforeend', `
                <div id="button-add-lamps" class="number-lamps__add">показать еще</div>
            `);
        }
    }
    if (command === 'delete') {
        numberLampsBody.innerHTML = '';
    }
};
exports.default = createButtonStillLamps;
